import { RevalidationTrigger } from '../models/onboarding.types';

/** Cadastros da conta (empresa, gestão e usuários) que mudam etapas de qualquer jornada. */
export const ACCOUNT_REVALIDATION_TRIGGERS: RevalidationTrigger[] = [
  { method: 'POST', urlPattern: String.raw`/leilao/empresa(/|\?|$)` },
  { method: 'PUT', urlPattern: String.raw`/leilao/empresa(/|\?|$)` },
  { method: 'POST', urlPattern: String.raw`/leilao/gestao(/|\?|$)` },
  { method: 'POST', urlPattern: String.raw`/leilao/usuario(/|\?|$)` },
  { method: 'PUT', urlPattern: '/leilao/usuario/' },
];
